var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-svgrepo-com (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 5.25C12 6.90686 10.6568 8.25 9 8.25C7.34314 8.25 6 6.90686 6 5.25C6 3.59314 7.34314 2.25 9 2.25C10.6568 2.25 12 3.59314 12 5.25Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 10.5C6.10051 10.5 3.75 12.8505 3.75 15.75H14.25C14.25 12.8505 11.8995 10.5 9 10.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.760904b0adc5b69cf7fa1cecfb4955d6.svg";
export { ForwardRef as ReactComponent };